import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LoginModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg max-w-md w-full mx-4">
        <h2 className="text-2xl font-bold mb-4 text-center">
          {t("modals.login.title")}
        </h2>
        <p className="text-gray-600 mb-6 text-center">
          {t("modals.login.message")}
        </p>
        <div className="flex flex-col gap-4">
          <button
            onClick={() => {
              navigate("/login");
              onClose();
            }}
            className="bg-primary text-white py-2 px-4 rounded-md hover:bg-primary-dark transition-colors"
          >
            {t("modals.login.loginButton")}
          </button>
          <button
            onClick={onClose}
            className="border border-gray-300 py-2 px-4 rounded-md hover:bg-gray-100 transition-colors"
          >
            {t("modals.login.maybeLater")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
